var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"mobile-top-nav"},[_c('button',{staticClass:"mobile-top-nav__back",attrs:{"type":"button","aria-label":"返回"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"el-icon-arrow-left"})]),_c('h1',{staticClass:"mobile-top-nav__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"mobile-top-nav__side"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }